import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ZkNotificationService } from '@zenklub/ng-ui';
import { IChatUser } from 'app/interfaces/chatuser.interface';
import { IPeriodOption } from 'app/interfaces/date.interface';
import { ChatService } from 'app/services/chat.service';
import { DateTimeService } from 'app/services/datetime.service';
import { UserService } from 'app/services/user.service';
import { environment } from 'environments/environment';
import { IContent } from 'shared/interfaces/content.interface';
import { ContactService } from 'shared/services/contact/contact.service';

@Component({
	selector: 'contact-content',
	templateUrl: './contact-content.component.html',
	styleUrls: ['./contact-content.component.scss'],
	providers: [ContactService],
})
export class ContactContent implements OnInit {
	loading = true;
	loadingChat = false;
	status:
		| 'fetchedContent'
		| 'noDataAccess'
		| 'noContent'
		| 'basicUser'
		| 'premiumUser'
		| 'checkingSubscription' = 'checkingSubscription';
	userContent: IContent;
	periodOptions: IPeriodOption[];
	firstName: string;

	@Input('contactId') contactId;
	@Input('contact') contact;

	constructor(
		private chatService: ChatService,
		private contactService: ContactService,
		private dateTimeService: DateTimeService,
		private notificationService: ZkNotificationService,
		private translateService: TranslateService,
		private userService: UserService
	) {}

	ngOnInit() {
		this.periodOptions = this.dateTimeService.getPeriodOptions().reverse();
		this.firstName = this.contact.displayName.split(' ')[0];

		this.userService
			.checkSubscriptionAndContactTiers()
			.then(({ hasActiveSubscription }) => {
				this.status = hasActiveSubscription ? 'premiumUser' : 'basicUser';
				this.loading = false;
			});
	}

	goToUrl(slug: string): void {
		window.open(`${environment.websiteurl}conteudo/${slug}`, '_blank');
	}

	openOfficeUrl(path: string): void {
		window.open(environment.officeUrl + path, '_blank');
	}

	async openChat(): Promise<void> {
		this.loadingChat = true;

		const startMessage = this.translateService.instant(
			'CONTACT.PAGES.CONTENT.INFO.REQUEST_DATA_MESSAGE',
			{ username: this.contact.displayName }
		);

		const chatUser: IChatUser = {
			email: this.contact.email,
			id: this.contact.refUserId,
			photoUrl: this.contact.photoUrl,
			role: this.chatService.role,
			username: this.contact.displayName,
		};
		const chatInbox = await this.chatService.startConversation(
			chatUser,
			'contact-contents-tab',
			startMessage
		);

		if (chatInbox) {
			this.loadingChat = false;
		}
	}

	getContent(period?: string) {
		if (this.status != 'basicUser') {
			this.loading = true;

			this.contactService.getContent(this.contactId, period).subscribe(
				(result) => {
					this.status = 'noContent';

					if (result && result?.contents?.length) {
						this.userContent = result;
						this.status = 'fetchedContent';
					}

					this.loading = false;
				},
				({ error }) => {
					this.loading = false;

					if (error.message == 'SharedPermissionNotFound') {
						this.status = 'noDataAccess';

						return;
					}

					this.notificationService.showError(error.messageI18n);
				}
			);
		}
	}
}
